import request from "@/utils/request";
export default {
  // 首页
  homeindex() {
    return request.get("/api/index/index");
  },
  // 交易接口
  Lotteryinfo(game_id) {
    return request.post("/api/Lottery/index", {
      game_id: game_id,
    });
  },
  //心跳
  heart(plan_id, game_id) {
    return request.post("/api/Lottery/heart", {
      plan_id: plan_id,
      game_id: game_id,
    });
  },
  //文章接口
  articleList() {
    return request.get("/api/index/articleList");
  },
  //文章接口
  oddsList(plan_id) {
    return request.post("/api/Lottery/oddsList", {
      plan_id: plan_id,
    });
  },
  //下注接口
  playOrder(data) {
    return request.post("/api/lottery/playOrder", {
      issue: data.issue,
      game_id: data.game_id,
      money: data.money,
      bet_content: data.bet_content,
    });
  },
  issueList(game_id) {
    return request.post("/api/Lottery/issueList", {
      game_id: game_id,

    });
  },
  cand(game_id) {
    return request.post("/api/Lottery/cand", {
      game_id: game_id,

    });
  },
  // 游戏列表接口
  gamelist() {
    return request.get("/api/index/gamelist");
  },
  // 获取彩票详情
  LotteryDetails(data) {
    return request.get('/api/index/LotteryDetails', { params: data });
  },
  // 自动结算接口
  settle() {
    return request.post("/api/lottery/settle");
  },
  // 获取历史数据
  lishi(game_id) {
    return request.get("/api/index/lishi", {
      params: { id: game_id }
    });
  },
};
